import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BasicItemResult } from '../../models/interfaces/basic-item-result.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { CRMOrganization, CRMOrganizationRequest } from '../../models/interfaces/crm-organization.interface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'
import { BasicNotificationsResult, NotificiationNameEnum } from '../../models/interfaces/basic-notifications.interface'

@Injectable({ providedIn: 'root' })
export class StageService {
   private readonly _cn = this.constructor.name
   private readonly _httpClient = inject(HttpClient)
   private readonly _logService = inject(LogService)
   private readonly _configService = inject(ConfigService)

   searchOrganizations(query: string): Observable<{ id: number; value: string }[]> {
      this._logService.info(this._cn, this.searchOrganizations.name, this._logService.START)
      this._logService.debug(this._cn, this.searchOrganizations.name, 'searching organizations...')
      this._logService.debug(this._cn, this.searchOrganizations.name, 'research grant query: ', query)
      const encodedQuery = encodeURIComponent(query)
      this._logService.debug(this._cn, this.searchOrganizations.name, 'encoded research grant query: ', encodedQuery)

      return this._httpClient.get<{ id: number; value: string }[]>(`${this._configService.new_BE_ApiUrl}/organisations?search=${encodedQuery}`)
   }

   searchOrganizationsList(query: string): Observable<BasicResult<CRMOrganizationRequest, CRMOrganization>> {
      let request: CRMOrganizationRequest = {
         listNames: [query],
         validated: true,
      }
      return this._httpClient.post<BasicResult<CRMOrganizationRequest, CRMOrganization>>(`${this._configService.new_BE_ApiUrl}/organisations/search`, request)
   }

   getSoughtPartnerCountries(): Observable<BasicItemResult[]> {
      this._logService.info(this._cn, this.getSoughtPartnerCountries.name, this._logService.START)
      return this._httpClient.get<BasicItemResult[]>(`${this._configService.new_BE_ApiUrl}/projects/countries?type=ISO_COUNTRIES`)
   }

   getSectors(): Observable<BasicItemResult[]> {
      this._logService.info(this._cn, this.getSectors.name, this._logService.START)
      return this._httpClient.get<BasicItemResult[]>(`${this._configService.new_BE_ApiUrl}/projects/sectors`)
   }

   getPNOUserNotifications(): Observable<BasicNotificationsResult> {
      this._logService.info(this._cn, this.getPNOUserNotifications.name, this._logService.START)
      let toolName = 'LINKING_TOOL'
      return this._httpClient.get<BasicNotificationsResult>(`${this._configService.old_BE_ApiUrl}/preferences/notifications?tool=${toolName}`)
   }

   updatePNOUserNotifications(notificationName: NotificiationNameEnum, isActive: boolean): Observable<any> {
      this._logService.info(this._cn, this.updatePNOUserNotifications.name, this._logService.START)
      let toolName = 'LINKING_TOOL'
      let requestBody = {
         enabled: isActive,
      }
      return this._httpClient.put(`${this._configService.old_BE_ApiUrl}/preferences/notifications/${toolName}/${notificationName}`, requestBody)
   }
}
